import { render, staticRenderFns } from "./DynamicQuickReplyMessageEditor.vue?vue&type=template&id=315800a9"
import script from "./DynamicQuickReplyMessageEditor.vue?vue&type=script&lang=js"
export * from "./DynamicQuickReplyMessageEditor.vue?vue&type=script&lang=js"
import style0 from "./DynamicQuickReplyMessageEditor.vue?vue&type=style&index=0&id=315800a9&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports